const setScrollbarWidth = ():void =>
	document.documentElement.style.setProperty("--scrollbar-width", (window.innerWidth - document.documentElement.clientWidth) + "px");

export const scrollbarWidth = ():void => {
	setScrollbarWidth();
	// recalculate on resize
	window.addEventListener("resize", setScrollbarWidth, false);
};
